import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="number-input"
export default class extends Controller {
  static values = {
    mode: {
      type: String,
      default: 'positive'
    },
    min: Number,
    max: Number,
    allowEmpty: { type: Boolean, default: true }
  }

  MODES = {
    positive: 'positive'
  }

  BLOCKED_KEYS_POSITIVE = [',', '-', 'e', 'E', '+']

  connect() {
    this.onInput = this.onInput.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
    this.element.addEventListener('input', this.onInput)
    this.element.addEventListener('keydown', this.onKeydown)
  }

  disconnect() {
    this.element.removeEventListener('input', this.onInput)
    this.element.removeEventListener('keydown', this.onKeydown)
  }

  onKeydown(event) {
    if (this.modeValue === this.MODES.positive && this.BLOCKED_KEYS_POSITIVE.includes(event.key)) {
      event.preventDefault()
    }
  }

  onInput(event) {
    this.sanitizeInput(event.target)
  }

  sanitizeInput(inputElement) {
    const originalValue = inputElement.value
    let value = originalValue

    if (this.modeValue === this.MODES.positive) {
      value = value.replace(/^-/, '')
    }

    value = value.replace(/[^\d.]/g, '')

    const parts = value.split('.')
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('')
    }

    if (value.match(/^0\d/) && !value.startsWith('0.')) {
      value = value.replace(/^0+/, '')
      if (value === '') value = '0'
    }

    if (value !== '.' && value !== '') {
      const parsed = parseFloat(value)
      if (isNaN(parsed)) {
        value = ''
      } else {
        if (!this.allowEmptyValue || value !== '') {
          if (this.hasMinValue && parsed < this.minValue) {
            if (!this.allowEmptyValue) {
              value = this.minValue.toString()
            }
          }
          if (this.hasMaxValue && parsed > this.maxValue) {
            value = this.maxValue.toString()
          }
        }
      }
    }

    if (value !== originalValue) {
      inputElement.value = value
      inputElement.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
    }
  }
}
